'use strict';

const _=require('pulsar-utils/dist-es6/_');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const moment=require('pulsar-utils/dist-es6/time/moment');let

ParamSyncService=class ParamSyncService extends BaseService{
static get $inject(){
return['$state','$location'];
}

constructor($state,$location){
super();
this._$state=$state;
this._$location=$location;
}

start(controller,$scope,onUrlChange){
let stateName=_.get(this._$state,'current.name');
let lastKnownUrl=this._$location.url();
$scope.$on('$locationChangeSuccess',()=>{
if(!this._$state.is(stateName)||lastKnownUrl===this._$location.url())
return;

let stateParams=_.get(this._$state,`params`);
onUrlChange(stateParams);
lastKnownUrl=this._$location.url();
});

return updatedParamsObject=>{
if(!this._$state.is(stateName))
return;

this._$state.go(stateName,updatedParamsObject);
};
}};


const IntervalSeparator='-to-';
const SerializedISOStringRegExpString='[\\d-]{10}T[\\d\\w\\:.]+';
const SerializedIntervalRegExp=new RegExp(`^${SerializedISOStringRegExpString}${IntervalSeparator}${SerializedISOStringRegExpString}$`);

const Synchronizers=[{
name:'Guid',
toUrl:val=>val.toString(),
fromUrl:valString=>Guid.fromString(valString),
is:instance=>instance instanceof Guid,
equals:(val1,val2)=>val1.toString()===val2.toString()},
{
name:'GuidString',
toUrl:val=>val,
fromUrl:val=>Guid.fromString(val)?val:void 0,
equals:(val1,val2)=>val1===val2,
is:val=>typeof val=='string'},
{
name:'Date',
toUrl:val=>val.toISOString(),
fromUrl:val=>{
const asDate=new Date(val);
return Number.isNaN(asDate.getTime())?void 0:asDate;
},
equals:(val1,val2)=>val1.valueOf()===val2.valueOf(),
is:val=>val instanceof Date},
{
name:'TimeInterval',
toUrl:val=>`${val.start.toISOString()}${IntervalSeparator}${val.end.toISOString()}`,
fromUrl:intervalString=>{
if(!SerializedIntervalRegExp.test(intervalString)){
return;
}

let[start,end]=intervalString.split(IntervalSeparator);
start=new Date(start);
end=new Date(end);
if(Number.isNaN(start.valueOf())||Number.isNaN(end.valueOf())){
return;
}

return TimeInterval.from(start).to(end);
},
equals:(interval1,interval2)=>interval1.equals(interval2),
is:instance=>instance instanceof TimeInterval},
{
name:'Timezone',
toUrl:timezone=>timezone,
fromUrl:timezoneString=>{
return _isTimezone(timezoneString)?timezoneString:void 0;
},
equals:(timezone1,timezone2)=>timezone1===timezone2,
is:timezone=>_isTimezone(timezone)},
{
name:'NotificationType',
toUrl:notificationType=>notificationType.name,
fromUrl:notificationTypeString=>{
return _.find(NotificationType.All,{name:notificationTypeString});
},
equals:(notificationType1,notificationType2)=>notificationType1===notificationType2,
is:notificationType=>notificationType instanceof NotificationType}];


function _isTimezone(timezone){
return typeof timezone=='string'&&_.exists(moment.tz.zone(timezone));
}

function _createUrlMatcherTypeDefinition(synchronizer){
let typeDef=_.merge({
encode:val=>encodeURIComponent(synchronizer.toUrl(val)),
decode:val=>{
try{
return synchronizer.fromUrl(decodeURIComponent(val));
}catch(e){
return;
}
}},
_.pick(synchronizer,['name','equals','is']));

return typeDef;
}

const SynchronizersAsUrlMatcherTypeDefinitions=Synchronizers.map(s=>_createUrlMatcherTypeDefinition(s));

let _initialized=!1;
function _loadUrlMatcherTypes($urlMatcherFactoryProvider){
if(_initialized){
return;
}

for(let synchronizer of SynchronizersAsUrlMatcherTypeDefinitions){
$urlMatcherFactoryProvider.type(synchronizer.name,synchronizer);
}

_initialized=!0;
};

module.exports=ParamSyncService;
module.exports.Synchronizers=_.keyBy(SynchronizersAsUrlMatcherTypeDefinitions,'name');
module.exports.LoadUrlMatcherTypes=_loadUrlMatcherTypes;
//# sourceMappingURL=paramSyncService.js.map
